import { Injectable } from '@angular/core';
import { StkmjServicePkg } from './stkmjPkg.service';


@Injectable({
  providedIn: 'root'
})
export class StkmjService extends StkmjServicePkg {
  constructor() {
    super();
    /*this.idNameOpt.sqlSelect= `SELECT ME001 as id,ME002 as name,ME001+'-'+ME002 as idName,ME002+'-'+ME001 as nameId,ME003 as ps1 FROM STKME `;
    this.idNameOpt.sqlWhere= `  `
    this.idNameOpt.sqlOrder= 'ORDER BY ME001';
    this.loadIdNameList(this.idNameOpt);*/

  }

}


